const budgetingScenarioQueryKeys = {
  all: [{ scope: 'budgetingScenario' }] as const,
  lists: () => [{ ...budgetingScenarioQueryKeys.all[0], entity: 'list' }] as const,
  list: (companyId: string) => [{ ...budgetingScenarioQueryKeys.lists()[0], companyId }] as const,
  detail: (companyId: string, scenarioId: string) =>
    [{ ...budgetingScenarioQueryKeys.all[0], entity: 'detail', companyId, scenarioId }] as const
}

export default budgetingScenarioQueryKeys
